import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-liability-svg',
  templateUrl: 'liability-svg.component.html'
})
export class LiabilitySvgComponent implements OnInit{

  @Input() height = "32"; 
  @Input() width = "32";
  viewbox:     string;

  ngOnInit() {
    this.viewbox = `0 0 ${this.width} ${this.height}`;
  }

}
